import type { LoadCurrentFolderPermissionsDependencies } from "./loadCurrentFolderPermissions";

interface AuthTokenLoaderModule {
  getOneDriveAccessToken(): Promise<string>;
  getSharePointAccessToken(): Promise<string>;
}

export const createLoadCurrentFolderPermissionsDependencies = ({
  authModule,
  getDriveItemSharepointUniqueIdFn,
  getUserEffectivePermissionsFn,
}: {
  authModule: AuthTokenLoaderModule;
  getDriveItemSharepointUniqueIdFn: NonNullable<LoadCurrentFolderPermissionsDependencies["getDriveItemSharepointUniqueIdFn"]>;
  getUserEffectivePermissionsFn: NonNullable<LoadCurrentFolderPermissionsDependencies["getUserEffectivePermissionsFn"]>;
}): Required<LoadCurrentFolderPermissionsDependencies> => ({
  getDriveItemSharepointUniqueIdFn,
  getOneDriveAccessTokenFn: () => authModule.getOneDriveAccessToken(),
  getSharePointAccessTokenFn: () => authModule.getSharePointAccessToken(),
  getUserEffectivePermissionsFn,
});
